module.exports = __webpack_public_path__ + "components/rewards/panda-optics/static/icon-5ff43bab1e86676b39a932082ee522d8.png";